export default {
	computed: {
		fontStyle() {
			return {
				fontFamily: this.$store.getters.settings.fontFamily
			}
		}
	},
};
